import { Children } from "react";
import { Space as AntdSpace } from "antd";
import type { CSSProperties, ReactNode } from "react";
import type { SpaceProps } from "antd";

interface SpaceWrapperProps extends SpaceProps {
  children?: ReactNode;
  showPlaceholder?: boolean;
  placeholderText?: string;
  placeholderStyle?: CSSProperties;
}

const defaultPlaceholderStyle: CSSProperties = {
  minHeight: 32,
  minWidth: 160,
  padding: "6px 10px",
  border: "1px dashed #d9d9d9",
  borderRadius: 6,
  color: "#999",
  fontSize: 12,
  lineHeight: "20px",
  textAlign: "center",
};

function SpaceWrapper({
  children,
  showPlaceholder = true,
  placeholderText = "拖拽组件到此处",
  placeholderStyle,
  ...props
}: SpaceWrapperProps) {
  // 仅在无子节点时展示占位提示，避免影响正常内容渲染。
  const hasChildren = Children.toArray(children).length > 0;

  return (
    <AntdSpace {...props}>
      {!hasChildren && showPlaceholder ? (
        <div style={{ ...defaultPlaceholderStyle, ...placeholderStyle }}>
          {placeholderText}
        </div>
      ) : (
        children
      )}
    </AntdSpace>
  );
}

export default SpaceWrapper;
